<template>
  <div>
    <v-dialog v-model="advance_search_application.show" width="500">
      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          Advance Search
        </v-card-title>
        <v-form v-model="valid" ref="form" class="filter-form">
          <v-card-text class="scroll-area">
            <v-menu
              ref="menu1"
              v-model="menu1"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="advance_search_application.start_date"
                  class="form-input"
                  label="Start Date"
                  prepend-icon="mdi-calendar"
                  v-bind="attrs"
                  v-on="on"
                  :rules="startDateRule"
                  filled
                  required
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="advance_search_application.start_date"
                no-title
                @input="menu1 = false"
              ></v-date-picker>
            </v-menu>

            <v-menu
              ref="menu2"
              v-model="menu2"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="advance_search_application.end_date"
                  class="form-input"
                  label="End Date"
                  prepend-icon="mdi-calendar"
                  v-bind="attrs"
                  v-on="on"
                  :rules="endDateRule"
                  filled
                  required
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="advance_search_application.end_date"
                :min="advance_search_application.start_date"
                @input="menu2 = false"
                no-title
              ></v-date-picker>
            </v-menu>

            <v-select
              v-model="advance_search_application.statuses"
              label="Status"
              :items="statuses"
              dense
              filled
              chips
              small-chips
              multiple
            ></v-select>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <md-button class="md-primary md-simple" @click="resetAdvanceSearch(true)">
              Reset
            </md-button>
            <v-spacer></v-spacer>
            <md-button class="md-primary md-simple" @click="showAdvanceFilter(false)">
              Cancel
            </md-button>
            <loading-icon-text-button
              @click="applyFilter"
              icon="search"
              :loading="saving"
              :disabled="!valid"
            >
              Apply
            </loading-icon-text-button>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
    <group-card title="Work Basket" icon="shopping_basket" padded>
      <template slot="actions">
        <md-button
          @click="showAdvanceFilter(true)"
          class="md-icon-button md-primary md-simple new-app-button"
        >
          <md-icon id="new-app-icon">filter</md-icon>
          Filter
          <md-tooltip md-direction="top">Advance Filter</md-tooltip>
        </md-button>

        <loading-icon-button
          @click="getAndUpdateWorkBasket(true)"
          tooltip="Refresh"
          :loading="status == 'loading'"
        >
          refresh
        </loading-icon-button>
      </template>
      <data-table
        title="Applications on your list"
        v-model="applications"
        :headers="headers"
        :items-per-page="50"
        :stickyheader="stickyHeader"
        @double-click="openApplicationEditor($event)"
        filterable
        editable-columns
      >
        <template v-slot:item.products_ko="{ item }">
          <md-button class="md-dense md-primary" @click="showKnockout(item)">
            Show
          </md-button>
        </template>
        <template v-slot:item.actions="{ item }">
          <md-menu
            md-size="medium"
            md-direction="bottom-start"
            class="action-menu"
          >
            <loading-icon-button
              md-menu-trigger
              tooltip="Click the 3 dots to see more"
              style="margin: 5px 1px"
            >
              more_vert
            </loading-icon-button>
            <md-menu-content class="action-menu">
              <md-menu-item @click="openApplicationEditorInNewTab(item)">
                <md-tooltip md-direction="left">
                  Open the loan application
                </md-tooltip>
                <md-icon>edit</md-icon>
                Open Application
              </md-menu-item>
              <md-menu-item
                @click="openApplicationSummary(item)"
                tooltip="Open Summary"
              >
                <md-tooltip md-direction="left">
                  Go to the loan application summary page
                </md-tooltip>
                <md-icon>launch</md-icon>
                Open Summary
              </md-menu-item>
            </md-menu-content>
          </md-menu>
        </template>
      </data-table>
    </group-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { GroupCard } from "@/components";
import ValidatedInputs from "@/components/ValidatedInput";
import DataTable from "@/components/DataTable";
import LoadingIconButton from "@/components/LoadingIconButton";
import LoadingIconTextButton from "@/components/LoadingIconTextButton";
import AdvanceSearchComponent from "@/components/AdvanceSearch/AdvanceSearchComponent";
import filters from "@/components/utils/filters";
import moment from "moment";

export default {
  components: {
    GroupCard,
    ...ValidatedInputs,
    LoadingIconButton,
    LoadingIconTextButton,
    AdvanceSearchComponent,
    DataTable,
  },
  data() {
    return {
      status: "unloaded",
      applications: [],
      statuses: ["Match", "Lender Missing", "False Decline"],
      stickyHeader: true,
      saving: false,
      valid: true,
      advance_search_application: {
        show: false,
        start_date: moment().add(-30, 'days').format('YYYY-MM-DD'),
        end_date: moment().format('YYYY-MM-DD'),
        statuses: [],
      },
      menu1: false,
      menu2: false,
      startDateRule: [
        v => !!v || 'Start date is required'
      ],
      endDateRule: [
        v => !!v || 'End date is required'
      ],
      headers: [
        {
          text: "ID",
          value: "app_no",
          sort: true,
          search: true,
          width: "80px",
        },
        {
          text: "Settlement Date",
          value: "Settlement Date",
          filter: filters.dateonly,
          sort: false,
          search: false,
          width: "92px",
        },
        {
          text: "Lender",
          value: "lender_name",
          sort: false,
          search: false,
        },
        {
          text: "Type",
          value: "loan_type",
          sort: false,
          search: true,
        },
        {
          text: "Status",
          value: "match_status",
          sort: false,
          search: true,
        },
        {
          text: "Options",
          value: "options",
          classFunction() {
            return "work-basket-overflow-item";
          },
          sort: false,
          search: false,
        },
        {
          text: "Relevant KOs",
          value: "relevant_products_ko",
          classFunction() {
            return "work-basket-overflow-item";
          },
          sort: false,
          search: false,
        },
        {
          text: "Comments",
          value: "comments",
          classFunction() {
            return "work-basket-overflow-item";
          },
          sort: false,
          search: false,
        },
        {
          text: "Naf",
          value: "NAF",
          filter: filters.currency,
          sort: false,
          search: false,
        },
        {
          text: "Rate",
          value: "Interest Rate",
          filter: filters.round,
          filter_args: [2],
          sort: false,
          search: false,
        },
        {
          text: "Veda 1.1",
          value: "Veda 1.1",
          sort: false,
          search: false,
        },
        {
          text: "Veda 2.0",
          value: "Veda 2.0",
          sort: false,
          search: false,
        },
        {
          text: "KOs",
          value: "products_ko",
          sort: false,
          search: false,
        },
        {
          text: "",
          value: "actions",
          align: "right",
          width: "45px",
          optional: false,
        },
      ],
    };
  },
  computed: {
    ...mapGetters(["options", "user", "userHasPermission"]),
  },
  methods: {
    ...filters,
    async getAndUpdateWorkBasket(resetFilter = false) {
      if (resetFilter) {
        this.resetAdvanceSearch(false);
      }
      this.status = "loading";
      this.applications = [];
      const postData = {
        start_date: this.advance_search_application.start_date,
        end_date: this.advance_search_application.end_date,
        generate_ids: false,
        statuses: this.advance_search_application.statuses,
      };
      await axios
        .post("/api/v1/reporting/baReporting", postData)
        .then((res) => {
          this.applications = res.data;
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.status = this.applications.length != 0 ? "loaded" : "error";
        });
    },
    openApplicationSummary(item) {
      if (item && item.app_no) {
        let url = `/application/${item.app_no}/summary`;
        window.open(url, "_blank").focus();
      }
    },
    openApplicationEditorInNewTab(item) {
      if (item && item.app_no) {
        let url = `/application/${item.app_no}/capture`;
        window.open(url, "_blank").focus();
      }
    },
    async openApplicationEditor(application) {
      this.$router.push(`/application/${application.app_no}/capture`);
    },
    showAdvanceFilter(show = false) {
      this.advance_search_application.show = show;
    },
    showKnockout(application) {
      this.$emit("showBaKnockout", application);
    },
    resetAdvanceSearch(show = false) {
      this.advance_search_application = {
        show: show,
        start_date: moment().add(-30, 'days').format('YYYY-MM-DD'),
        end_date: moment().format('YYYY-MM-DD'),
        statuses: [],
      }
    },
    applyFilter() {
      this.advance_search_application.show = false;
      this.getAndUpdateWorkBasket();
    },
  },
  filters: {
    ...filters,
  },
  async created() {
    this.getAndUpdateWorkBasket();
  },
};
</script>
<style scoped lang="scss">
@import "../assets/scss/theme.scss";
@import "../assets/scss/md-custom/_ausloans-colors.scss";

button.md-button.md-icon-button.md-primary.md-simple.new-app-button {
  width: 150px !important;
  font-size: 12px !important;
  color: #ffffff !important;
  background-color: $ausloans-blue !important;
}

::v-deep .v-date-picker-table .v-btn.v-btn--active {
  color: #fff;
  background: #0014ff;
}

.scroll-area {
  max-height: 280px;
  overflow: auto;
}

form.v-form.filter-form .v-card__text.scroll-area {
  padding: 17px !important;
}

::v-deep .work-basket-overflow-item {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  &:hover {
    white-space: revert;
    word-break: break-all;
  }
}
</style>
